import { formatToCurrencyType } from "helper/common";
import React from "react";
import {ColumnProps} from "types/models";
import { ColumnsEdit } from "types/models/column-table-edit";
const columns: ColumnProps[] = [
  {
    title: "STT",
    dataIndex: "STT",
    show: true,
    render(value, record, index) {
      return <div>{index + 1}</div>;
    },
    align: "center",
  },
  {title: "Tên bệnh sử", dataIndex: "benhSu", show: true, align: "left"},
  {title: "Ghi chú", dataIndex: "ghiChu", show: true, align: "left"},
];

const columnsTableMenu: ColumnsEdit = [
  {
    title: "STT",
    key: "stt",
    align: "center",
    render: (v, r, i) => i + 1,
    width: 30,
  },
  {
    title: "Tên gói",
    dataIndex: "tenGoiDichVu",
    key: "tenGoiDichVu",
    align: "center",
    width: 150,
  },
  {
    title: "Đơn giá BV",
    dataIndex: "giaBv",
    key: "giaBv",
    align: "right",
    width: 80,
    render: (v) => formatToCurrencyType(v),
  },
  {
    title: "Đơn giá BH",
    dataIndex: "giaBH",
    key: "giaBH",
    align: "right",
    width: 80,
    render: (v) => formatToCurrencyType(v),
  },
  {
    title: "Tỷ lên miễn giảm BHYT BN",
    dataIndex: "tyLeMienGiam",
    key: "tyLeMienGiam",
    align: "right",
    width: 80,
    render: (v) => `${formatToCurrencyType(v)}%`,

  },
  {
    title: "Tổng NB trả",
    dataIndex: "tongNbTra",
    key: "tongNbTra",
    align: "right",
    width: 80,
  },
  
];
export {columns,columnsTableMenu};
